<template>
  <div>
    <div class="subtitle-2" style="align-items: flex-start;" v-if="GETTERS_INPUT_ALL.last_status_id > 4">
      <b>Запланирован эксперимент :</b>
      <br />
      <div style="padding-right:30px;">
        <span>
          <v-icon>mdi-arrow-left</v-icon>
            Расписание "переехало" в раздел "Команда, Расписание и Пропуска"
          <br />
        </span>
      </div>

      <!-- <v-list-item>
        <template>
          <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
            <v-btn
              @click="click_debug()"
              outlined
              width="100%"
            >{{"CLICK for debug"}}</v-btn>
          </div>
        </template>
      </v-list-item> -->
    </div>

    <div class="bs-actions">
        <div v-if="editable.buttons.bs_addComment" class="bs-actions__text">
            <h4>{{$t('Actions.rate_comment')}}</h4>

            <v-container fluid>
              <v-radio-group
                v-model="bs_resolution"
                :inline=true
              >
                <v-radio
                  :label= "$t('Actions.impossible')"
                  color="error"
                  value="1"
                ></v-radio>
                <v-radio
                  :label="$t('Actions.maybe')"
                  color="success"
                  value="2"
                ></v-radio>
              </v-radio-group>

              <v-textarea
                class="bs-actions__textarea"
                v-model="commentActions"
                outlined
                :maxlength="1000"
                counter
                color="#15336d"
                name="input-7-4"
                style='color:#15336d'
                label="Комментарий"
                :key="id"
              ></v-textarea>
              <div class="my-2">
              <v-btn
              outlined
              :loading="loaded"
              :disabled="commentActions.length === 0 || bs_resolution == 0"
              @click="dialogConfirm = true"
                  color="#15336d">{{$t('Actions.save')}}</v-btn>
              </div>
            </v-container>
        </div>

        <v-dialog v-model="dialogConfirm" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('Actions.confirmation')}}</v-card-title>
                <v-card-text>{{$t('Actions.want_application_experiment')}}</v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" outlined :color="$mainColor" @click="dialogConfirm = false">{{$t('cancel')}}</v-btn>
                <v-btn color="green darken-1" outlined :color="$mainColor" @click="dialogConfirm = false, addCommentToCard()">{{$t('sent')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
      </div>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
export default {
  components: {
  },
    name: 'Actions',

    props: {
        id: [String, Number],
        editable: [Object, Array],
    },
    computed: {
        ...mapGetters([
          'GETTERS_LOGIN',
          'GETTERS_INPUT_ALL',
        ]),
    },

    data() {
        return {
            loaded: false,
            dialogConfirm: false,
            checkComment: false,
            commentActions: '',
            proposal_calendar: [],
            availiable_limit: 0,
            delete_loaded: false,
            bs_resolution: 0,
            delete_item_id: null,
        }
    },

    methods: {
        ...mapActions([
          'ADD_COMMENT',
        ]),

        addCommentToCard() {
            this.loaded = true

            this.ADD_COMMENT({
                user: this.GETTERS_LOGIN,
                proposal: this.id,
                text: this.commentActions,
                kind: 'bs',
                bs_resolution: this.bs_resolution,
            })
            .then(() => {

                this.loaded = false
                this.checkComment = false
                this.commentActions = ''
                this.$emit('reloadParent')
                this.$emit('closeProposalDialog');
            })
            .catch(() => {
                this.checkComment = false
                this.loaded = false
            })
        },

        click_debug(){
        },
    }
}
</script>
<style>
    .bs-actions {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .bs-actions__text,
    .bs-actions__textarea {
        width: 100%;
        margin-left:0px;
        margin-right:15px;
        /* background-color:rgba(229,115,115,0.4); */
    }

    .bs-actions__text {
        padding: 15px 15px 0 15px;
        /* border: 1px solid red; */
        background-color:rgba(255,255,255,0);
        border-radius:8px;
        margin-top:20px;
    }

    .v-input--selection-controls {
        margin-top: 0;
    }
    .bs-actions__save {
        padding-top: 15px;
        padding-bottom: 15px;
    }
</style>
